import { render, staticRenderFns } from "./goodsClass.vue?vue&type=template&id=2ed065f1&scoped=true&"
import script from "./goodsClass.vue?vue&type=script&lang=js&"
export * from "./goodsClass.vue?vue&type=script&lang=js&"
import style0 from "./goodsClass.vue?vue&type=style&index=0&id=2ed065f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed065f1",
  null
  
)

export default component.exports